import { initialState } from '..';
import type { BetSlipState } from '../types';
import { getIsAvailableOpportunity } from '../utils/getIsOpportunity';

const priceChangesAccepted = (
  state: BetSlipState,
  opportunities: BetSlipState['opportunities']
): BetSlipState => ({
  ...state,
  opportunities,
  receipt: initialState.receipt,
  acceptedOdds: [...opportunities.SINGLE, ...opportunities.MULTIPLE].reduce<
    BetSlipState['acceptedOdds']
  >((acc, next) => {
    acc[next.id] = getIsAvailableOpportunity(next) ? next.winRunnerOdds : undefined;

    return acc;
  }, {})
});

export default priceChangesAccepted;
